export default __webpack_public_path__ + "static/media/artist_snoop.5fad6d4c.jpg";